<template>
    <div class="bigcardCont">
        <div class="bigcard">
            <Image v-if="cover" :image="cover" :width="1200" :height="400" :mobileHeight="800" imageClass="cover" />
            <div class="contentBox">
                <div class="title3" role="heading">{{ titolo }}</div>
                <div v-if="sottotitolo" class="paragraph" v-html="sottotitolo"></div>
            </div>
            <template v-if="link">
                <div class="iconLink">
                    <NIconWrapper :size="42" color="white" :border-radius="21">
                        <NIcon size="1.412rem" color="var(--color-text-default)" :component="KeyboardArrowRightRound" :aria-label="$t('freccia')"></NIcon>
                    </NIconWrapper>
                </div>
                <a v-if="link && isExternal" class="overlink" :href="link" target="_blank" :aria-label="titolo"></a>
                <NuxtLinkLocale v-if="link && !isExternal" class="overlink" :to="link" :aria-label="titolo"></NuxtLinkLocale>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { NIconWrapper, NIcon } from 'naive-ui'
import { KeyboardArrowRightRound } from '@vicons/material'

interface Props {
    cover?: any,
    tag?: string,
    titolo?: string,
    sottotitolo?: string,
    descrizione?: string,
    link?: any,
    isExternal?: boolean
}
defineProps<Props>()

// TODO tassonomia?
</script>

<style lang="scss" scoped>
.bigcardCont {
    position: relative;
    height: 400px;
    width: 100%;

    .bigcard {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background-color: var(--color-background-image);
        border-radius: var(--size-card-radius);
        overflow: hidden;

        .contentBox {
            background-color: var(--color-background-box);
            position: absolute;
            bottom: var(--margin-default);
            left: var(--margin-default);
            padding: var(--margin-default) var(--margin-default) var(--margin-double) var(--margin-default);

            border-radius: var(--size-card-radius-inner);
            max-width: 400px;
            box-sizing: border-box;

            display: flex;
            flex-direction: column;
            gap: var(--margin-default);
        }

        .iconLink {
            position: absolute;
            bottom: var(--margin-default);
            right: var(--margin-default);
        }
    }
}

@media screen and (max-width: 600px) {
    .bigcardCont {
        .bigcard {

            .contentBox {
                left: 10px;
                right: 10px;
                bottom: 10px;
                padding-bottom: var(--margin-default);
            }

            .iconLink {
                display: none
            }
        }
    }
}
</style>